import React, { useEffect, useState } from "react";
import { Paper, Typography, Divider, Box } from "@material-ui/core";
import DataTable from "../../Components/DataTable";
import { Api } from "../../api/client";
import { num, money } from "../../utils/format";

export default function FrecuentesNuevos(){

  const [data,setData]=useState(null);

  useEffect(()=>{
    async function load(){
      const r=await Api.customersStats({});
      setData(r);
    }
    load();
  },[]);

  const columns=[
    {key:"cliente",label:"Cliente"},
    {key:"pedidos",label:"Pedidos",render:r=>num(r.pedidos)},
    {key:"gasto",label:"Gasto",render:r=>money(r.gasto)}
  ];

  return (
    <Paper style={{padding:18,borderRadius:14}}>
      <Typography variant="h6" style={{fontWeight:900}}>Frecuentes y nuevos</Typography>
      <Divider style={{margin:"12px 0"}}/>

      {data && (
        <>
          <Box display="flex" gridGap={20}>
            <div><b>Frecuentes:</b> {num(data.frecuentes)}</div>
            <div><b>Nuevos:</b> {num(data.nuevos)}</div>
          </Box>

          <Box mt={3}>
            <DataTable columns={columns} rows={data.topFrecuentes || []}/>
          </Box>
        </>
      )}
    </Paper>
  );
}